<template>
    <div class="container-fluid" id="about" v-if="show">
        <div class="eyecatch">
            <img src="/img/about/03.jpg" alt="アイキャッチ・小説を読む" class="img-fluid mx-auto d-block about" />
        </div>
        <div class="container mincho">
            <links></links>
            <h2 class="text-center" id="read">
                <i class="fas fa-book-open"></i>
                小説を読む
            </h2>
            <div class="desc">
                <p>
                    貸し本棚の小説はユーザー登録しなくても読むことができます。
                    スマートフォン、タブレット、PCなど、各種デバイスサイズに最適なレイアウトで小説が表示され、
                    特別な設定は必要ありませんが、お好みでフォントサイズや色テーマを変更したり、
                    縦書きやノベルゲーム風の文字打ちを設定することができます。
                </p>
            </div>
            <div class="row my-2">
                <div class="col-md-4">
                    <h5 class="small-caption">縦書き</h5>
                    <img v-lazy="'/img/about/r01.png'" alt="縦書き" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        既定では横書きで表示されますが、設定を変更することで縦書き表示することも可能です。
                        他にも色テーマを変更してダークモードにしたり、フォントをゴシックに変更したり、
                        文字サイズを４種類から選ぶことができます。<br>
                        いずれも可読性の高い、読書に最適な行間とレイアウト、文字色を設定しますので、
                        細かい調整は必要ありません。
                    </div>
                </div>
                <div class="col-md-4">
                    <h5 class="small-caption">自動栞</h5>
                    <img v-lazy="'/img/about/r02.png'" alt="栞" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        最後に読んだエピソードを自動的に記憶します。<br>
                        ユーザー登録すると、読書履歴の一覧をみて、当該エピソードに遷移することができます。
                        文字打ち設定の場合は、出力した文字位置も記憶します。
                    </div>
                </div>
                <div class="col-md-4">
                    <h5 class="small-caption">電子書籍</h5>
                    <img v-lazy="'/img/about/r03.png'" alt="電子書籍" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        完結作品はepub形式の電子書籍を出力します。
                        電子書籍はiBookなどの電子書籍リーダーで読むことができ、オフラインでも問題なく開けます。
                        <div class="text-success">
                            ※作者様が電子書籍化を許可している場合に限る
                        </div>
                    </div>
                </div>
            </div>
            <div class="row my-2">
                <div class="col-md-4">
                    <h5 class="small-caption">拍手と感想</h5>
                    <img v-lazy="'/img/about/r04.png'" alt="拍手と感想" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        作品に拍手ボタンが用意されている場合、拍手ボタンをクリックするだけで、
                        読者は匿名で作者に感謝を伝えることができます。<br>
                        続けて感想欄が開いたら、作品への感想を送ることもできます。
                    </div>
                </div>
                <div class="col-md-4">
                    <h5 class="small-caption">お気に入り</h5>
                    <img v-lazy="'/img/about/r05.png'" alt="お気に入り" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        ログインしているとき、作品をお気に入りに入れることができます。
                        お気に入りの作品が更新されると、通知に表示されます。<br>
                        お気に入りの作家さんをフォローすることで、その作家さんがいずれかの作品を更新したとき、
                        通知を受け取ることもできます。
                    </div>
                </div>
                <div class="col-md-4">
                    <h5 class="small-caption">文字打ち</h5>
                    <img v-lazy="'/img/about/r06.png'" alt="文字打ち" class="img-fluid img-desc mx-auto d-block" />
                    <div class="mt-2">
                        貸し本棚が備えるもうひとつの奇妙な機能に、ノベルゲーム風の文字打ち機能があります。
                        レイアウト設定から文字出力速度とカーソル音を選択すれば、
                        まるでノベルゲームのように小説本文が打ち出されます。<br>
                        この状態の時、打ち出した位置を自動栞として記憶するため、どこまで読んだかわからなくなることはありません。
                    </div>
                </div>
            </div>
            <h3 class="caption">作品を展示する</h3>
            <div class="mb-3">
                <img src="/img/help/read/06.jpg" alt="お気に入り作品を展示する" class="img-fluid">
            </div>
            <div class="mb-3">
                作品を執筆しなくても、ご自身の本棚を作成して、そこにお気に入りの作品を展示することができます。
                事物としての本来の「貸し本棚」のように、これらの展示作品のあるあなたの本棚をSNSに掲載して紹介することもできます。
                あるいは貸し本棚の中のデジタル本棚として利用することができます。
            </div>
            <h3 class="caption">読者様もユーザー登録をおすすめします</h3>
            <div class="row">
                <div class="col-lg-3">
                    <div class="row">
                        <div class="col-lg icon-column">
                            <img v-lazy="'/img/about/icon01.png'" class="img-icon" />
                        </div>
                        <div class="col-lg px-4">
                            お気に入りに追加した小説、フォローした作者の更新情報が通知されます。<br>
                            また、作者に感想を送ったり、その返信を貰うことができます。
                            それらの返信も通知されます。
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="row">
                        <div class="col-lg icon-column">
                            <img v-lazy="'/img/about/icon02.png'" class="img-icon" />
                        </div>
                        <div class="col-lg px-4">
                            最後に読んだ部分が履歴に残ります。<br>
                            栞機能はありませんが、読んだ小説をすべて記録します。
                            もし履歴に残したくないものがあれば、任意に削除することも可能です。<br>
                            まだユーザ登録をしていない状態で、複数の小説を読んでいても、登録時にその履歴を流し込みます。
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="row">
                        <div class="col-lg icon-column">
                            <img v-lazy="'/img/about/icon03.png'" class="img-icon" />
                        </div>
                        <div class="col-lg px-4">
                            本文の書式を変更できます。<br>
                            縦書きにしたり、ゴシックフォントにしたり、背景色を選ぶことができます。
                            それらの設定がキャッシュをクリアしたり、一定期間が経過したときに、
                            意に反して失われることは有りません。
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="row">
                        <div class="col-lg icon-column">
                            <img v-lazy="'/img/about/icon04.png'" class="img-icon" />
                        </div>
                        <div class="col-lg px-4">
                            お気に入りに小説を追加できます。<br>
                            お気に入りに追加した小説は、あなたのマイページから読むことができます。
                            追加できるお気に入りの数に制限はありません。
                        </div>
                    </div>
                </div>
            </div>
            <div class="row d-flex justify-content-center mt-5">
                <div class="col-md-8">
                    <p>
                        ユーザー登録は簡単です。
                        お名前とメールアドレス、8文字以上のパスワードを決めるだけです。<br>
                        Googleアカウントをお持ちの方は、
                        連携ログインのボタンをクリックするだけでアカウントを作成することができます。<br>
                        次回からも、連携ログインボタンのクリックだけでログインすることができます。
                    </p>
                </div>
            </div>
            <div class="mt-5">
                <links></links>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.eyecatch {
    background-color: #CDD8DA;
}
.about {
    max-height: 640px;
}
.desc {
    font-size: 1.1rem;
    margin-bottom: 2.5rem;
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
}
.caption {
    margin: 3rem 0 .8rem;
    padding: .5rem 0;
    border-bottom: 1px dashed #ddd;
}
.img-desc {
    border: 1px solid #ddd;
    border-radius: .2rem;
}
.img-tips {
    width: 350px;
    height: 350px;
}
.img-icon {
    object-fit: cover;
    width: 64px;
    height: 64px;
}
.icon-column {
    max-width: 64px;
}
.small-caption {
    font-weight: bold;
    text-align: center;
    margin-top: 2rem;
}
#about {
    padding-right: 0px;
    padding-left: 0px;
    h2 {
        margin-top: 5rem;
        margin-bottom: 1rem;
    }
}
</style>

<script>
import links from "./links";
export default {
    components: {
        links
    },
    data() {
        return {
            show: true
        }
    },
    mounted() {
        this.useHead({
            title: "小説を読む | 貸し本棚",
            link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
        });
    }
}
</script>